export default function Hero() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="relative min-h-screen flex items-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0 z-0">
        <img 
          src="https://public.readdy.ai/ai/img_res/ae77e50b16d1c43db30636ebf58869a6.jpg"
          alt="Professional workspace"
          className="w-full h-full object-cover object-top animate-[zoomIn_20s_ease-in-out_infinite_alternate]"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/50"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 md:px-6 py-20 md:py-32 w-full">
        <div className="grid md:grid-cols-2 gap-8 md:gap-12 items-center">
          <div className="text-white animate-[fadeInUp_1s_ease-out]">
            <div className="inline-block bg-white/20 backdrop-blur-sm px-4 md:px-5 py-2 md:py-2.5 rounded-full mb-4 md:mb-6 border border-white/30 shadow-lg animate-[slideInLeft_0.8s_ease-out]">
              <span className="text-xs md:text-sm font-medium">✨ 14 päivän maksuton kokeilu</span>
            </div>
            
            <h2 className="text-2xl md:text-3xl lg:text-7xl font-bold mb-4 md:mb-6 leading-tight text-white font-inter animate-[fadeInUp_1s_ease-out_0.2s_both]">
              Hanki enemmän <img src="https://www.google.com/images/branding/googlelogo/2x/googlelogo_light_color_92x30dp.png" alt="Google" className="inline-block h-6 md:h-8 lg:h-16 align-middle mx-1" />-arvosteluja automaattisesti
            </h2>
            
            <p className="text-base md:text-xl mb-6 md:mb-8 text-white/95 leading-relaxed animate-[fadeInUp_1s_ease-out_0.4s_both]">
              Boostio lähettää asiakkaillesi helpon palautekyselyn sähköpostilla ja ohjaa tyytyväiset asiakkaat jättämään Google-arvostelun. Ilman manuaalista työtä.
            </p>
            
            <div className="flex flex-col md:flex-row flex-wrap gap-3 md:gap-4 animate-[fadeInUp_1s_ease-out_0.6s_both]">
              <button onClick={() => scrollToSection('trial-form')} className="w-full md:w-auto bg-gradient-to-r from-[#1E3A8A] to-[#2563EB] text-white px-8 md:px-10 py-4 md:py-5 rounded-full hover:from-[#172554] hover:to-[#1E3A8A] transition-all duration-300 cursor-pointer whitespace-nowrap font-semibold text-base md:text-lg shadow-2xl hover:shadow-[#1E3A8A]/50 hover:scale-105 transform">
                Aloita ilmainen kokeilu
              </button>
              <button onClick={() => scrollToSection('pricing')} className="w-full md:w-auto bg-white/10 backdrop-blur-sm text-white px-8 md:px-10 py-4 md:py-5 rounded-full hover:bg-white/20 transition-all duration-300 cursor-pointer whitespace-nowrap border-2 border-white/40 font-semibold text-base md:text-lg hover:scale-105 transform">
                Hinnasto
              </button>
            </div>
          </div>

          <div className="animate-[fadeInRight_1s_ease-out_0.4s_both]">
            <div className="bg-white rounded-2xl md:rounded-[2rem] shadow-2xl p-4 md:p-8 transform hover:scale-105 transition-all duration-500 hover:shadow-[0_25px_50px_-12px_rgba(0,0,0,0.25)]">
              <div className="bg-gradient-to-br from-[#F8FAFC] to-white rounded-xl md:rounded-[1.5rem] p-4 md:p-8">
                <div className="flex items-center justify-between mb-4 md:mb-8">
                  <h3 className="text-lg md:text-2xl font-bold text-gray-800">Google-arvostelut</h3>
                  <div className="bg-gradient-to-r from-green-400 to-green-600 text-white px-3 md:px-4 py-1.5 md:py-2 rounded-full text-xs md:text-sm font-semibold shadow-lg animate-pulse">
                    +24% tällä viikolla
                  </div>
                </div>
                
                <div className="space-y-3 md:space-y-5">
                  {[
                    { name: 'Maria Virtanen', rating: 5, text: 'Erinomainen palvelu! Suosittelen lämpimästi.' },
                    { name: 'Jukka Nieminen', rating: 5, text: 'Nopea ja ammattitaitoinen. Kiitos!' },
                    { name: 'Laura Korhonen', rating: 5, text: 'Paras kokemus pitkään aikaan.' }
                  ].map((review, idx) => (
                    <div key={idx} className="bg-white rounded-xl md:rounded-[1.2rem] p-3 md:p-5 shadow-md border border-gray-100 hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1 animate-[fadeInUp_0.6s_ease-out] hover:border-[#3B82F6]/20" style={{ animationDelay: `${idx * 0.15}s` }}>
                      <div className="flex items-center gap-2 md:gap-3 mb-2 md:mb-3">
                        <div className="w-10 h-10 md:w-12 md:h-12 bg-gradient-to-br from-[#3B82F6] to-[#1E3A8A] rounded-full flex items-center justify-center text-white font-semibold shadow-lg text-sm md:text-base">
                          {review.name.charAt(0)}
                        </div>
                        <div className="flex-1">
                          <div className="font-semibold text-gray-800 text-sm md:text-base">{review.name}</div>
                          <div className="flex text-yellow-400 text-xs md:text-sm">
                            {[...Array(review.rating)].map((_, i) => (
                              <i key={i} className="ri-star-fill"></i>
                            ))}
                          </div>
                        </div>
                      </div>
                      <p className="text-gray-600 text-xs md:text-sm leading-relaxed">{review.text}</p>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <style>{`
        @keyframes fadeInUp {
          from {
            opacity: 0;
            transform: translateY(30px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
        @keyframes fadeInRight {
          from {
            opacity: 0;
            transform: translateX(30px);
          }
          to {
            opacity: 1;
            transform: translateX(0);
          }
        }
        @keyframes slideInLeft {
          from {
            opacity: 0;
            transform: translateX(-30px);
          }
          to {
            opacity: 1;
            transform: translateX(0);
          }
        }
        @keyframes zoomIn {
          from {
            transform: scale(1);
          }
          to {
            transform: scale(1.05);
          }
        }
      `}</style>
    </section>
  );
}